import { render, staticRenderFns } from "./SortAscending.vue?vue&type=template&id=a9943f46"
import script from "./SortAscending.vue?vue&type=script&lang=js"
export * from "./SortAscending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports